module.exports = __webpack_public_path__ + "img/album_banner.dff92c7d.png";